import axios from "axios";

const generalClient = axios.create({
  timeout: 10000,
  headers: {
    "Content-Type": "application/json"
  }
});


export default generalClient;